import React from "react";
import PageTemplate from "../components/PageTemplate";
import PlansMobileHeader from "../components/plans/PlansMobileHeader";
import PlansBody from "../components/plans/PlansBody";
import {useLocation} from "react-router-dom";

const Plans = () => {
  const query = new URLSearchParams(useLocation().search);

  if (query.get('coupon')) {
    sessionStorage.setItem('coupon', query.get('coupon'));
  }

  return (
    <PageTemplate
      title='Plans'
      sidebarTitle='Choose A Plan'
      sidebarSubtitle='We have multiple plans that fit every business.'
      mobileHeader={<PlansMobileHeader />}
      centered
    >
      <PlansBody />
    </PageTemplate>
  );
};

export default Plans;
